import { createContext } from 'react';

import {
  ApiSite,
  ApiSiteStatus,
  ApiSiteTab,
} from '@totem/components/administration/apiSites/types';

interface Context {
  loading: boolean;
  data: ApiSite[];
  filteredData: ApiSite[];
  activeTab: ApiSiteTab;
  editingSite: ApiSite | null;
  modalOpen: boolean;
  onRefresh: () => void;
  onEdit: (site: ApiSite) => void;
  onModalClose: () => void;
  onSave: (site: Partial<ApiSite>) => void;
  onStatusChange: (id: string, status: ApiSiteStatus) => void;
  onTabChange: (tab: ApiSiteTab) => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  filteredData: [],
  activeTab: 'current',
  editingSite: null,
  modalOpen: false,
  onRefresh: () => {},
  onEdit: () => {},
  onModalClose: () => {},
  onSave: () => {},
  onStatusChange: () => {},
  onTabChange: () => {},
});
